import { useState, useEffect } from "react"

import UserPanelTabs from "./UP_Tabs"
import "./UserPanel.css"

const UserPanelMain = ({ tab: initialTab, user }) => {
  const [tab, setTab] = useState(initialTab)

  useEffect(() => {
    setTab(initialTab)
  }, [initialTab])

  return (
    <div className="UserPanel h-100 justify-content-center">
      <UserPanelTabs tab={tab} setTab={setTab} user={user} />
    </div>
  )
}

export default UserPanelMain
